import palette from '../../palette';

export default {
  toolbar: {
    backgroundColor: palette.blueMain,
    height: "auto",
    paddingTop: "10px",
    paddingBottom: "10px"
  }
};
